import { defineMessages } from 'react-intl-next';

export const messages: {
	threadTypeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	messageTypeLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	lastActive: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	attachedDateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	privateChannelLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	memberCount: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	smartlinkAttachmentsExpandButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fileAttachmentsExpandButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	threadTypeLabel: {
		id: 'relay.search-result.thread-type-label',
		defaultMessage: 'Thread',
		description: 'Message metadata label',
	},
	messageTypeLabel: {
		id: 'relay.search-result.message-type-label',
		defaultMessage: 'Message',
		description: 'Message metadata label',
	},
	lastActive: {
		id: 'relay.search-result.message-last-active',
		defaultMessage: 'Last active {formattedDate}',
		description: 'Message metadata label',
	},
	attachedDateLabel: {
		id: 'relay.search-result.attachments.attached-date.label',
		defaultMessage: 'Attached {formattedDate}',
		description: 'Attachments showin the date the attachment was added',
	},
	privateChannelLabel: {
		id: 'relay.search-result.private-channel-label',
		defaultMessage: 'Private Channel',
		description: 'Private channel metadata label',
	},
	memberCount: {
		id: 'relay.search-page.results.product-results.third-party.message-search-result.member-count',
		defaultMessage: '{count, plural, one {# member} other {# members}}',
		description: 'Use to describe the number of members in a conversation',
	},
	smartlinkAttachmentsExpandButtonLabel: {
		id: 'relay.search-page.results.product-results.third-party.message-search-result.smartlink-attachments-expand-button-label',
		defaultMessage: '{count, plural, one {# link} other {# links}}',
		description: 'Use to describe the number of links shared in a conversation',
	},

	fileAttachmentsExpandButtonLabel: {
		id: 'relay.search-page.results.product-results.third-party.message-search-result.file-attachments-expand-button-label',
		defaultMessage: '{count, plural, one {# attachment} other {# attachments}}',
		description: 'Use to describe the number of file attachments shared in a conversation',
	},
});
